<template>
    <div class="flex flex-col h-full">
        <!-- Search -->
        <div class="mb-4">
            <div class="mb-2 text-md font-semibold text-gray-700 dark:text-white">People You Talk To</div>
            <div class="relative">
                <SearchIcon class="absolute top-2 left-3 w-5 h-5 text-gray-400" />
                <input
                    v-model="keywords"
                    type="text"
                    class="w-full pl-10 pr-4 py-2 bg-gray-100 dark:bg-gray-800 rounded-full text-sm placeholder-gray-400 border-none shadow-sm focus:ring-0 focus:shadow-md"
                    placeholder="Search user..."
                />
            </div>
        </div>

        <!-- Chat List -->
        <div class="flex-grow overflow-y-auto">
            <div v-if="!isLoading">
                <div v-if="userList.length">
                    <a
                        v-for="user in userList"
                        :key="user.id"
                        @click="selectUser(user)"
                        class="flex items-center gap-3 px-4 py-3 cursor-pointer transition-all duration-200 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700"
                        :class="{
                            'bg-gray-100 border-l-4 border-green-500': isCurrentRecipient(user),
                        }"
                    >
                        <img
                            class="object-cover w-10 h-10 mx-1 rounded-full"
                            :src="user.profile_photo_url"
                            alt="avatar"
                        />
                        <div class="flex-1 min-w-0">
                            <div class="flex justify-between items-center mb-0.5">
                                <p
                                    class="text-sm font-medium truncate"
                                    :class="{ 'font-bold text-gray-900 dark:text-white': !user.read_at }"
                                >
                                    {{ user.name }}
                                </p>
                                <span class="text-xs text-gray-400 whitespace-nowrap">
                                    {{ user.latestMessage?.created_at | fromNow }}
                                </span>
                            </div>
                            <p
                                class="text-xs text-gray-500 truncate line-clamp-1"
                                :class="{ 'font-semibold text-gray-600 dark:text-gray-300': !user.read_at }"
                            >
                                {{ user.latestMessage?.message || 'No messages yet' }}
                            </p>
                        </div>
                    </a>
                </div>
                <div
                    v-else
                    class="mt-8 text-center text-sm text-gray-400"
                >
                    No users found
                </div>
            </div>
            <div
                v-else
                class="mt-8 text-center text-sm text-gray-400"
            >
                Loading...
            </div>
        </div>
    </div>
</template>

<script>
    import SearchIcon from './Icons/SearchIcon.vue';

    export default {
        components: {
            SearchIcon,
        },

        props: {
            value: { type: String },
            userList: { type: Array },
            isCurrentRecipient: { type: Function },
            isLoading: { type: Boolean },
        },

        data() {
            return {
                keywords: this.value,
            };
        },

        computed: {
            currentUserList() {
                return this.users.filter((user) => user.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
            },
        },

        watch: {
            keywords: {
                handler() {
                    this.$emit('input', this.keywords);
                },
            },
        },

        methods: {
            selectUser(user) {
                this.keywords = '';
                this.$emit('onUserSelect', user);
            },
        },
    };
</script>
